import { useEffect, useRef } from 'react';
import useActiveState from "../lib/useActiveState";
import URI from "urijs";

// 全局处理标记，防止多个组件实例重复执行
const globalProcessing = {};

const useWindowMessage = (handlers = {}, enabled = true) => {
  const [agent] = useActiveState('agent');
  
  // 使用 useRef 保存最新的回调函数，避免 useEffect 依赖变化导致频繁解绑绑定
  const handlersRef = useRef(handlers);
  
  // 每次渲染都更新 ref.current，保证拿到最新的函数引用
  useEffect(() => {
    handlersRef.current = handlers;
  });

  useEffect(() => {
    // 如果不启用，则不添加监听器
    if (!enabled) {
      return;
    }

    const handleMessage = (event) => {
      const result = event.data;      
      if (result?.type) {
        if (result.type === "nisptb") {
          // 立即标记正在处理，防止在判断期间收到重复消息
          if (globalProcessing[result.type]) {
            return;
          }
          globalProcessing[result.type] = true;
          
          // 检查当前URL，避免重复跳转
          const currentHash = window.location.hash;
          if (currentHash.includes('sinfo=nisptb')) {
            console.log("已在平台币页面，跳过跳转");
            globalProcessing[result.type] = false;
            return;
          }
          
          //跳转平台币
          let url = URI("https://sys.99maiyou.com/home/MixPay/ptb")
            .addQuery("username", localStorage.getItem("username"))
            .addQuery("token", localStorage.getItem("token"))
            .addQuery("location_url", window.location.origin)
            .addQuery("agent", agent)
            .addQuery("from", "react")
            .toString();

          const targetUrl = "#/iframe?url=" +
            encodeURIComponent(url) +
            "&title=充值&sinfo=nisptb";

          // 使用 replace 替代 href，避免在历史记录中添加多条记录
          window.location.replace(targetUrl);
          
          // 页面跳转后，在新页面重置标记
          setTimeout(() => {
            globalProcessing[result.type] = false;
          }, 3000);
          return;
        }
        
        // 其他消息类型的防重复处理
        if (globalProcessing[result.type]) {
          return;
        }
        
        if(result.type === 'close_pay') {
          //重新加载 - 调用回调
          if (handlersRef.current.onClosePay) {
            handlersRef.current.onClosePay();
          }
        }
        if(result.type === 'div_heigt') {
          if (handlersRef.current.onDivHeight) {
            handlersRef.current.onDivHeight(result.heigt);
          }
        }
        if(result.type === 'realname') {
          if (handlersRef.current.onRealname) {
            handlersRef.current.onRealname();
          }
        }
        if(result.type === 'share') {          
          const data = JSON.parse(result.data);
          if (handlersRef.current.onShare) {
            handlersRef.current.onShare(data);
          }
        }
      }
    };

    window.addEventListener("message", handleMessage);

    // 清理函数
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [agent, enabled]); // agent 或 enabled 变化时重新绑定
};

export default useWindowMessage;
